<script setup>
</script>

<template>
  <div class="h-full bg-n-background flex flex-col w-full">
    <!-- Header da página -->
    <header
      class="flex justify-between items-center h-14 min-h-[3.5rem] px-4 py-2 bg-white dark:bg-slate-900 border-b border-n-slate-6 pl-6">
      <div class="flex justify- items-center gap-2">
        <woot-sidemenu-icon v-if="showSidemenuIcon" />
        <h1 class="text-2xl font-semibold font-interDisplay tracking-[0.3px] text-slate-900 dark:text-slate-25">
          Funil de ADS
        </h1>
      </div>
    </header>
    
    <!-- Mensagem temporária "Em breve" -->
    <div class="w-full h-full flex items-center justify-center p-8">
      <div class="text-center max-w-md">
        <div class="mb-6">
          <div class="w-24 h-24 mx-auto mb-4 bg-n-slate-3 rounded-full flex items-center justify-center">
            <svg class="w-12 h-12 text-n-slate-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
        </div>
        <h2 class="text-2xl font-semibold text-n-slate-12 mb-3">
          Funcionalidade em Desenvolvimento
        </h2>
        <p class="text-n-slate-10 text-lg mb-6">
          As informacões dos Leads do Meta Ads estará disponível em breve. 
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.animate-fade-in {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>